import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import LeagueCalendar from './Widgets/LeagueCalendar';
import LeagueInfo from './Widgets/LeagueInfo';
import LeagueRanking from './Widgets/LeagueRanking';

const LeagueSupport = () => (
  <div id="league-support">
    <header className="content-header">
      <h1>
        League
        <small>support</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-life-saver" /> Support
        </li>
        <li className="text-bold">
          <Link to="/league-support">League</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <div className="row">
        <div className="col-md-12">
          <LeagueInfo />
        </div>
        <div className="col-md-12">
          <LeagueRanking />
        </div>
        <div className="col-md-12">
          <LeagueCalendar />
        </div>
      </div>
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(LeagueSupport);



// WEBPACK FOOTER //
// ./src/pages/Support/League/index.js